(function () {
    var els = document.querySelectorAll('.sj-reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('sj-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('sj-in');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      els.forEach(function (el) { io.observe(el); });
    }

    // Product gallery: click a thumbnail to swap the main image
    document.querySelectorAll('.sj-gallery').forEach(function (gallery) {
      var mainImg = gallery.querySelector('.sj-gallery-main-img');
      var thumbs = gallery.querySelectorAll('.sj-thumb');
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-src');
          if (mainImg && src) { mainImg.src = src; }
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    });
  })();
